import type { MaybeType } from "@/shared/types";

export interface PaymentPlan {
  tariffPlanId: string;
  externalId: string;
  name: string;
  description: string;
  type: string;
  price: number;
  activePeriod: number;
  storePeriod: number;
}

export enum PaymentStatus {
  WAITING_FOR_PAYMENT = "waiting_for_payment",
  PAID = "paid",
  CANCELED = "canceled",
  WAITING_FOR_CAPTURE = "waiting_for_capture",
}

export enum CountFrequency {
  ONCE = "ONCE",
  EVERY_MONTH = "EVERY_MONTH",
}

export enum CurrencyCode {
  RUR = "RUB",
  USD = "USD",
  AED = "AED",
}

export interface LocalizedValue {
  ru: string;
  en: string;
}

export interface TariffPrice {
  amount: string;
  currencyCode: CurrencyCode;
}

interface TariffOptionItem {
  id: string;
  name: string;
  localizedName: LocalizedValue;
  description: string;
  localizedDescription: LocalizedValue;
  order: number;
  price: TariffPrice;
  count: number;
  countFrequency: CountFrequency;
}

export interface TariffOption {
  id: string;
  name: string;
  localizedName: LocalizedValue;
  description: string;
  localizedDescription: LocalizedValue;
  order: number;
  type: string;
  items: TariffOptionItem[];
}

export interface Tariff {
  tariffPlanId: string;
  externalId: string;
  name: string;
  localizedName: LocalizedValue;
  description: string;
  localizedDescription: LocalizedValue;
  type: string;
  price: TariffPrice;
  options: TariffOption[];
}

export type AllTariffResponse = Tariff[];

export type AllPaymentPlansResponse = PaymentPlan[];

export interface SelectedTariffOption {
  optionId: MaybeType<string>;
  optionItemId: MaybeType<string>;
}

export interface CalculatePricePayload {
  tariffId: string;
  discount?: {
    code: string;
  };
  options?: SelectedTariffOption[];
}

export interface CalculatePriceResponse {
  amount: string;
  finalAmount: string;
  discount: string;
  discountCode: string;
  currencyCode: CurrencyCode;
}

export interface PaymentUrlPayload {
  tariffPlanId: string;
  idempotenceKey: string;
  redirectUrl: string;
  discount?: {
    code: string;
  };
  options?: SelectedTariffOption[];
  lastPrice: CalculatePriceResponse;
}

export interface PaymentUrlResponse {
  paymentOperationId: string;
  idempotenceKey: string;
  paymentSystemOperationId: string;
  createdDate: string;
  customerId: string;
  state: PaymentStatus;
  tariffPlan: string;
  subscriptionId: string;
  cancelSubscriptionId: string;
  type: string;
  amount: number;
  paymentSystem: string;
  paymentSystemState: string;
  paymentSystemCreatedAt: string;
  paymentSystemExpiresAt: string;
  paymentUrl: string;
  fulfilled: true;
  description: string;
}
